import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { ProductListComponent } from "../product-list/product-list.component";
import { AccountListComponent } from "../account-list/account-list.component";
import { EnergyStorageComponent } from "../Page/energy-storage/energy-storage.component";
import { SmartPanelComponent } from "../Page/smart-panel/smart-panel.component";
import { AdrSystemComponent } from "../Page/adr-system/adr-system.component";


export const routes: Routes = [
  { path: "", component: SmartPanelComponent },
  { path: "user", component: AccountListComponent },
  { path: "product", component: ProductListComponent },
  { path: "product/energystorage", component: EnergyStorageComponent },
  { path: "product/energystorage/:uuid", component: EnergyStorageComponent },
  { path: "product/smartpanel", component: SmartPanelComponent },
  { path: "product/smartpanel/:uuid", component: SmartPanelComponent },
  { path: "product/adrsystem", component: AdrSystemComponent },
  { path: "product/adrsystem/:gwId/:mId", component: AdrSystemComponent },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)], // forChild
  exports: [RouterModule]
})
export class RouteRoutingModule { }



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/route/route-routing.module.ts